module.exports = __webpack_public_path__ + "img/mainonhold.05d13ba3.svg";